import React from 'react';
import {inject, observer} from 'mobx-react';
import Fade from '@mui/material/Fade';
import cx from 'classnames';

import {LLProgressBar, LLTextSlider} from '../../../../components';
import Markets from '../../components/common/markets';
import trans from '../../../../common/utils/trans';


const SubMarketGroupsSlider = (
    {
        store,
        activeMarketGroup,
        setActiveMarketGroup,
        marketGroups,
        userCanCashout,
        matchInstance
    }
) => {
    const
        activeItems = store.betting.activeItems,
        isOldView = store.user.isOldMarketsView,
        setOldView = store.user.setMarketViewType,
        marketGroup = marketGroups[activeMarketGroup];

    const renderMarketGroupsTabs = (marketGroups) => (
        <LLTextSlider
            id="market-subgroups__slider"
            viewSize={store.site.status.viewSize}
            customClasses={{
                slider: "market-subgroups__slider",
                arrow: 'market-subgroups__slider-arrow',
            }}
            activeItem={activeMarketGroup}
        >
            {marketGroups.map((marketGroup) => {
                return (
                    <div
                        className={cx(
                            'market-subgroups__slider-item',
                            activeMarketGroup === marketGroup.id && 'active'
                        )}
                        onClick={() => {
                            setActiveMarketGroup(marketGroup.id);
                            activeItems.setActiveItem(
                                [marketGroup.id.toString()],
                                'marketGroups'
                            );
                        }}
                        id={marketGroup.id}
                        key={marketGroup.id}
                    >
                        {marketGroup.shortName ?? marketGroup.name}
                    </div>
                );
            })}
        </LLTextSlider>
    );

    if (!!marketGroups.length && !!matchInstance.oddsCount) {
        return (
            <>
                {matchInstance?.initialFetching ? (
                    <LLProgressBar customClasses="pre-match-details__progress-bar" />
                ) : (
                    <>
                        {renderMarketGroupsTabs(marketGroups)}
                        <Fade in={!marketGroup?.initialFetching}>
                            <div>
                                <Markets
                                    match={matchInstance}
                                    marketGroup={matchInstance.marketGroups.get(activeMarketGroup)}
                                    sportId={matchInstance.sportId}
                                    userCanCashout={userCanCashout}
                                    viewSize={store.site.status.viewSize}
                                    isOldView={isOldView}
                                    setOldView={setOldView}
                                    isMarketsTabView={true}
                                    activeMarketGroup={activeMarketGroup}
                                    user={store.user}
                                    favorites={store.betting.favorites}
                                    withoutSpecifierBasedHeader={true}
                                />
                            </div>
                        </Fade>
                    </>
                )}
            </>
        );
    } else {
        return (
            <div className="match-details__empty-markets">
                {trans('EMPTY_BETS_ERROR')}
            </div>
        );
    }
};
export default inject('store')(observer(SubMarketGroupsSlider));
